export default __webpack_public_path__ + "static/oak-e57f3a0ed2ff699d9c13f6b91635f8e1.jpg";